import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useRace } from '@/hooks/useRaces';
import { DEFAULT_RACE_IMAGE } from '@/config/constants';
import EventDetailView from './eventdetailpage.view';

const EventDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: race, isLoading: loading } = useRace(id);

  const event = useMemo(() => {
    if (!race) return null;
    return {
      id: race.id,
      title: race.name,
      subtitle: '',
      location: race.location,
      organizer: race.admin?.name || 'Unknown',
      organizerId: race.adminId,
      date: race.startDate?.split('T')[0] || '',
      time: race.startDate?.split('T')[1]?.substring(0, 5) || '',
      image: DEFAULT_RACE_IMAGE,
      status: race.status?.toLowerCase() || 'upcoming',
      description: race.description || ''
    };
  }, [race]);

  return (
    <EventDetailView
      event={event}
      loading={loading}
      navigate={navigate}
    />
  );
};

export default EventDetailPage;
